module.exports = {"130982001":"新华路街道","130982002":"西环路街道","130982003":"永丰路街道","130982004":"中华路街道","130982005":"渤海路街道","130982006":"油建路街道","130982007":"会战道街道","130982100":"出岸镇","130982101":"石门桥镇","130982102":"吕公堡镇","130982103":"长丰镇","130982106":"梁召镇","130982107":"辛中驿镇","130982108":"麻家坞镇","130982109":"北辛庄镇","130982110":"议论堡镇","130982204":"青塔乡","130982207":"北汉乡","130982208":"于村乡","130982400":"华北石油管理局","130982500":"河北任丘经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130982.json
// module id = 316
// module chunks = 0